export const updatedAtIndex = <T>(array: T[], targetIndex: number, newValue: T): T[] =>
  array.map((item, i) => (i === targetIndex ? newValue : item))
